import axios from "axios";
import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import * as Yup from "yup";
import togetherIcon from "../../components/images/Together.png";
import DotedPart from "../common/DotedPart";
import contactIcon4 from "../images/contactIcon4.png";
import CircleRightTop from "../images/EllipseTeamTopLeft.png";
import CircleLeftBottom from "../images/EllipseRightBottom.png";
import contactIcon6 from "../images/contactIcon6.png";
import contactIcon3 from "../images/contactIcon3.png";
import arrow_btn from "../images/arrow_btn.svg";
import contactIcon2 from "../images/contactIcon2.png";
import contactIcon5 from "../images/contactIcon5.png";
import contactIcon1 from "../images/contactIcon1.png";
import Loader from "../../spinner.svg";
import Marque from "../common/Marque";
import { useTranslation } from "react-i18next";

const IndexContactUs = () => {
  const { t } = useTranslation();
  const [userDetails, setUserDetails] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Subject: "",
    Message: "",
    Timestemp: new Date(),
    Location: "",
  });
  const [disable, setdisable] = useState(true);
  const [loading, setLoading] = useState(false);

  const contactUsIcons = [
    { image: contactIcon1, height: "42px" },
    { image: contactIcon2, height: "45px" },
    { image: contactIcon3, height: "60px" },
    { image: contactIcon4, height: "44px" },
    { image: contactIcon1, height: "42px" },
    { image: contactIcon5, height: "32px" },
    { image: contactIcon6, height: "33px" },
    { image: contactIcon2, height: "45px" },
    { image: contactIcon4, height: "44px" },
    { image: contactIcon6, height: "33px" },
    { image: contactIcon3, height: "60px" },
  ];

  const subjectOptions = [
    { label: t("demo_omni_platform"), value: t("demo_omni_platform") },
    { label: t("omni_ifrs9_reporting"), value: t("omni_ifrs9_reporting") },
    { label: t("omni_basel_reporting"), value: t("omni_basel_reporting") },
    { label: t("omni_esg_reporting"), value: t("omni_esg_reporting") },
    {
      label: t("omni_business_reporting"),
      value: t("omni_business_reporting"),
    },
    { label: t("omni_warehousing_cap"), value: t("omni_warehousing_cap") },
    {
      label: t("inquiry_vitta_business_service"),
      value: t("inquiry_vitta_business_service"),
    },
    { label: t("other_queries"), value: t("other_queries") },
  ];

  const URL =
    "https://script.google.com/macros/s/AKfycbxYM0mQOV7keXhU2KBGWosfvuVAqRCpfG2PrQl3OjyuWtKhdZw84ck7K7k00hgDXrkxVg/exec";

  const validationSchema = Yup.object({
    FirstName: Yup.string()
      .required(t("first_name_required"))
      .max(50, t("first_name_must_required"))
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        t("first_name_latin_required")
      ),
    LastName: Yup.string()
      .required(t("last_name_required"))
      .max(50, t("last_name_must_required"))
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        t("last_name_latin_required")
      ),
    Email: Yup.string()
      .email(t("business_valid_email"))
      .required(t("business_email_required"))
      .max(50, t("business_email_latin_required")),
    Subject: Yup.string().required(t("subject_required")),
    Message: Yup.string().required(t("message_required")),
  });

  const handleGetLocation = async () => {
    try {
      await axios
        .get("https://ipinfo.io/json?token=eb6488a0cbe69c")
        .then((res) => {
          setUserDetails({
            ...userDetails,
            Location: `${res.data.city},${res.data.region},${res.data.country}`,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    handleGetLocation();
    // eslint-disable-next-line
  }, []);

  const textInputRef = useRef(null);

  const handleTab = (e) => {
    if (e?.key === "Tab") {
      e.preventDefault();
      textInputRef.current.focus();
    }
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    const formdata = new FormData();
    Object.keys(userDetails).map((key) => {
      return formdata.append(key, userDetails[key]);
    });
    fetch(URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: formdata,
    })
      .then((res) => {
        toast.success("Your query successfully sent");
        setUserDetails({
          ...userDetails,
          FirstName: "",
          LastName: "",
          Email: "",
          Subject: "",
          Message: "",
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="contactUs_main mt-[150px]">
        <img
          draggable="false"
          src={CircleRightTop}
          className="back_circle1Contact"
          alt="back_circle1"
        />
        <img
          draggable="false"
          src={CircleLeftBottom}
          className="back_circle2Contact"
          alt="back_circle2"
        />
        <div className="container mt-[150px] mx-auto px-2 pb-5 md:pb-0 xl:max-w-[1000px] 3xl:max-w-[1400px] sm:text-start">
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-[5%] lg:gap-[15%] my-[50px] sm:my-[80px] md:my-[100px] mx-[0px] sm:mx-[16px] lg:my-[80px] 3xl:mt-[180px] 3xl:mb-[70px] ">
            <div className="text-center md:text-left">
              <div className="pb-5">
                <button className="sora font-[600] px-2 sm:px-4 py-1 text-[14px] sm:text-[16px] sm:py-2 text-[#3359D3] border border-opacity-40 border-[#3359D3] rounded-[38px]">
                  {t("contact_us")}
                </button>
              </div>
              <div className="flex flex-col justify-center md:justify-start gap-2 sm:flex-row lg:flex-col mb-[40px]">
                <span className="text-[30px] sm:text-[34px] leading-[45px] sm:leading-[50px] md:leading-[58px] 3xl:leading-[80px] md:text-[36px] 3xl:text-[51px] font-[700] text-[#141619] capitalize">
                  {t("speak_with")}
                </span>
                <span className="text-[30px] sm:text-[34px] leading-[45px] sm:leading-[50px] md:leading-[58px] 3xl:leading-[80px] md:text-[36px] 3xl:text-[51px] font-[700] text-[#141619] capitalize">
                  {t("our_expert")}
                </span>
              </div>
              <span className="sora text-[#444] text-[14px] 3xl:text-[18px] pt-5">
                {t("contact_us_desc")}
              </span>
            </div>
            <div className="mt-6 sm:mt-0">
              <Formik
                validateOnMount={true}
                validateOnBlur={true}
                validateOnChange={true}
                initialValues={{
                  FirstName: "",
                  LastName: "",
                  Email: "",
                  Subject: "",
                  Message: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(
                  values,
                  { resetForm, setSubmitting, setValues, setFieldValue }
                ) => {
                  console.log(values);
                  const Email = values.Email?.toLowerCase();
                  const submitValue = {
                    ...values,
                    Email,
                    Timestemp: new Date().toString(),
                    Location: userDetails.Location,
                  };

                  const userValues = JSON.stringify(submitValue);
                  console.log(userValues);
                  axios
                    .post(`${URL}`, userValues)
                    .then((response) => {
                      console.log(response);
                      setValues("Subject", null);

                      toast.success("submitted successfully");
                      resetForm();
                    })
                    .catch((error) => {
                      toast.error("something went wrong");
                    })
                    .finally(() => {
                      setSubmitting(false);
                      // setValues("Subject", "");
                    });
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  getFieldProps,
                  handleChange,
                  setFieldValue,
                  handleBlur,
                  setValues,
                  isSubmitting,
                }) => {
                  const disable = Object.keys(errors).length !== 0;
                  return (
                    <form
                      className="form_contactUsMain rounded-[4px]  sm:rounded-[20px] "
                      onSubmit={handleSubmit}
                    >
                      <div className=" bg-[#fff]  p-[10px] sm:p-[30px] form_contact rounded-[4px]  sm:rounded-[20px] right-0">
                        <div className="mb-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label
                              htmlFor="text"
                              className="sora block text-[14px] font-normal text-[#344054]"
                            >
                              {t("first_name")}
                              <span className="text-[14px] font-normal text-[#E43D18]">
                                *
                              </span>
                            </label>
                            <input
                              id="FirstName"
                              type="text"
                              className="sora FasterWithIntegrations_inputBox w-full p-2.5 placeholder:text-[14px] placeholder:text-[#667085]"
                              placeholder={t("first_name")}
                              {...getFieldProps("FirstName")}
                            />
                            {touched.FirstName && errors.FirstName && (
                              <p className="sora text-[#D32F2F] text-[12px]">
                                {errors.FirstName}
                              </p>
                            )}
                          </div>
                          <div>
                            <label
                              htmlFor="text"
                              className="sora block text-[14px] font-normal text-[#344054]"
                            >
                              {t("last_name")}
                              <span className="text-[14px] font-normal text-[#E43D18]">
                                *
                              </span>
                            </label>
                            <input
                              type="text"
                              id="LastName"
                              className="sora FasterWithIntegrations_inputBox w-full p-2.5 placeholder:text-[14px] placeholder:text-[#667085]"
                              placeholder={t("last_name")}
                              {...getFieldProps("LastName")}
                            />
                            {touched.LastName && errors.LastName && (
                              <p className="sora text-[#D32F2F] text-[12px]">
                                {errors.LastName}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="mb-6 grid grid-cols-1 gap-4">
                          <div>
                            <label
                              htmlFor="text"
                              className="sora block text-[14px] font-normal text-[#344054]"
                            >
                              {t("business_email")}
                              <span className="text-[14px] font-normal text-[#E43D18]">
                                *
                              </span>
                            </label>
                            <input
                              value={values.Email.toLowerCase()}
                              name="Email"
                              onBlur={handleBlur}
                              type="text"
                              id="Email"
                              className="sora FasterWithIntegrations_inputBox w-full p-2.5 placeholder:text-[14px] placeholder:text-[#667085]"
                              placeholder={t("business_email")}
                              {...getFieldProps("Email")}
                            />
                            {touched.Email && errors.Email && (
                              <p className="sora text-[#D32F2F] text-[12px]">
                                {errors.Email}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="mb-6 grid grid-cols-1  ">
                          <label
                            htmlFor="text"
                            className="sora block text-[14px] font-normal text-[#344054]"
                          >
                            {t("subject")}
                            <span className="text-[14px] font-normal text-[#E43D18]">
                              *
                            </span>
                          </label>
                          <select
                            id="Subject"
                            name="Subject"
                            className="sora py-2.5 px-2 w-full rounded-md border border-gray-300"
                            onChange={handleChange}
                            value={values.Subject}
                            style={{
                              color: values.Subject === "" && "#667085",
                              fontSize: values.Subject === "" && "15px",
                              // fontWeight: values.Subject === "" && "lighter",
                            }}
                          >
                            <option disabled value="" className="sora">
                              {t("select_subject")}
                            </option>
                            {subjectOptions.map((item, index) => (
                              <option
                                key={index}
                                value={item.value}
                                className="sora"
                              >
                                {item.label}
                              </option>
                            ))}
                            {/* <option
                              value="Demonstration of OMNI, regulatory technology"
                              className="sora"
                            >
                              {t("option2")}
                            </option> */}
                            {/* <option value="Explore DySE, lending decision technology in more detail">
                              Explore DySE, lending decision technology in more
                              detail
                            </option> */}
                            {/* <option
                              value="Explore DySE, lending decision technology in more detail"
                              className="sora"
                            >
                              {t("other_queries")}
                            </option> */}
                          </select>
                          {touched.Subject && errors.Subject && (
                            <p className="sora text-[#D32F2F] text-[12px]">
                              {errors.Subject}
                            </p>
                          )}
                        </div>

                        <div>
                          <label
                            htmlFor="text"
                            className="sora block text-[14px] font-normal text-[#344054]"
                          >
                            {t("your_message")}
                            <span className="text-[14px] font-normal text-[#E43D18]">
                              *
                            </span>
                          </label>
                          <textarea
                            id="Message"
                            type="text"
                            rows={3}
                            className="sora FasterWithIntegrations_inputBox w-full p-2.5 placeholder:text-[14px] placeholder:text-[#667085]"
                            placeholder={t("your_message")}
                            {...getFieldProps("Message")}
                          />
                          {touched.Message && errors.Message && (
                            <p className="sora text-[#D32F2F] text-[12px] mt-[-5px]">
                              {errors.Message}
                            </p>
                          )}
                        </div>
                        <div className="requestDemoBtnOuter requestDemoBtnOuter_bigSize  mt-[30px]">
                          <button
                            disabled={disable || isSubmitting}
                            type="submit"
                            className={`sora requestDemoBtn requestDemoBtn_bigSize `}
                          >
                            {isSubmitting && (
                              <img
                                src={Loader}
                                className="w-7 object-cover mr-2"
                                alt="Loader"
                              />
                            )}
                            {t("send_request")}
                            <img
                              draggable="false"
                              src={arrow_btn}
                              className="w-[9px] sm:w-[12px] ml-[4px]"
                              alt="Arrow_up_small"
                            />
                          </button>
                        </div>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-[50px] lg:mb-[50px] sm:mb-[50px]">
        <Marque
          className="mb-[0px] 2xl:mb-[70px]"
          iconList={contactUsIcons}
          title={t("affiliations_clients")}
        />
      </div>
      <div className="container mx-auto px-2 xl:max-w-[1000px] 3xl:max-w-[1400px] flex flex-col items-center">
        <h1 className="relative sora font-bold capitalize text-[700] text-[20px] md:text-[30px] lg:text-[40px] 3xl:text-[54px] leading-[35px] md:leading-[50px] lg:leading-[65px] 3xl:leading-[80px] lg:w-max text-center">
          <img
            draggable="false"
            src={togetherIcon}
            alt=""
            className="absolute left-[0px] sm:left-[-40px] md:left-[-50px] lg:left-[-60px] top-[-30px] sm:top-[-20px] md:top-[-25px] lg:top-[-30px] xl:top-[] w-[70px] lg:w-[120px] md:w-[95px]"
          />
          {t("unify_compliance_data")}
        </h1>
        <h1 className="sora font-bold capitalize text-[700] text-[20px] md:text-[30px] lg:text-[40px] 3xl:text-[54px] leading-[35px] md:leading-[50px] lg:leading-[65px] 3xl:leading-[80px] text-center">
          {t("streamline_reporting")}
        </h1>
        <div className="pt-5">
          <span className="sora text-[#444444] text-[14px] 3xl:text-[18px] text-center flex justify-center">
            {t("streamline_reporting_desc")}
          </span>
        </div>
      </div>
      <DotedPart className="my-[50px] md:my-[89px]" />
    </>
  );
};

export default IndexContactUs;
